"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Slip = (function () {
    function Slip() {
        this.playedMatches = {};
        this.playedQuotas = [];
        this.matchOrder = [];
        this.matchCount = 0;
        this.system = 0;
        this.combinations = 0;
        this.maxWin = 0;
    }
    Slip.prototype.removeAllMatches = function () {
        $('.bvg-btn').removeClass('active');
        for (var key in this.matchOrder) {
            this.removeMatch(parseInt(this.matchOrder[key]));
        }
        ;
    };
    Slip.prototype.getTicketJSON = function () {
        if (Object.keys(this.playedMatches).length < 1 || Object.keys(this.matchOrder).length < 1 || this.matchCount < 1) {
            return false;
        }
        else {
            var matches = [];
            for (var key in this.playedMatches) {
                matches.push(key + '-' + this.playedMatches[key][5]);
            }
            var system = this.matchCount;
            if (this.system != 0) {
                system = this.system;
            }
            var response = {
                'NewFootballTicket': {
                    'SessionID': window['customLoggedIn'] && window['customToken'] ? window['customToken'] : window['token'],
                    'TicketAmount': $('#slip-btn').val(),
                    'System': system,
                    'Items': '|' + matches.join('|') + '|'
                }
            };
            return response;
        }
    };
    Slip.prototype.addMatch = function (match, tip, code, quota, quotaId) {
        if (match.status == 0) {
            if (this.matchOrder.indexOf('' + match['ID']) == -1) {
                this.matchOrder.push('' + match['ID']);
            }
            this.playedMatches['' + match['ID']] = [quotaId, match.home, match.away, tip, quota, code];
            this.update();
        }
        else {
            console.log("Unable to bet - match finished");
        }
    };
    Slip.prototype.removeMatch = function (matchId) {
        delete this.matchOrder[this.matchOrder.indexOf('' + matchId)];
        delete this.playedMatches['' + matchId];
        this.update();
    };
    Slip.prototype.removeFinishedMatches = function (matches) {
        for (var key in this.matchOrder) {
            var matchId = this.matchOrder[key];
            if (matches[matchId]['status'] == "1") {
                delete this.matchOrder[this.matchOrder.indexOf('' + matchId)];
                delete this.playedMatches['' + matchId];
            }
        }
        this.update();
    };
    Slip.prototype.isPlayedQuota = function (matchId, quotaId) {
        if (undefined !== this.playedMatches[matchId]) {
            if (this.playedMatches[matchId][0] == quotaId) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    Slip.prototype.recalculate = function () {
        var system = this.matchCount;
        if (this.system != 0) {
            system = this.system;
        }
        console.log(system);
        this.combinations = this.factorial(this.matchCount) / (this.factorial(system) * this.factorial(this.matchCount - system));
        this.playedQuotas = [];
        for (var key in this.playedMatches) {
            this.playedQuotas.push(this.playedMatches[key][4] + '');
        }
        var maxWinCalculated = window['CalcCombination']($('#slip-btn').val(), this.playedQuotas, system);
        if (maxWinCalculated <= window['footballMaxWin']) {
            this.maxWin = maxWinCalculated;
        }
        else {
            this.maxWin = window['footballMaxWin'];
        }
    };
    Slip.prototype.update = function () {
        var matchCountChanged = false;
        if (this.matchCount !== Object.keys(this.matchOrder).length) {
            matchCountChanged = true;
        }
        this.matchCount = Object.keys(this.matchOrder).length;
        this.updateSystem(matchCountChanged);
        this.recalculate();
        this.updateHTML();
    };
    Slip.prototype.updateSystem = function (matchCountChanged) {
        if (matchCountChanged) {
            $('.styled-checkbox').prop('disabled', true);
            $('.styled-checkbox').prop('checked', false);
            this.system = 0;
            var id = 0;
            if (Object.keys(this.matchOrder).length > 1) {
                $('.slip-systems').addClass('active');
                for (var key in Object.keys(this.matchOrder)) {
                    id = parseInt(key);
                    $('#styled-checkbox-' + id).prop('disabled', false);
                }
            }
            else {
                $('.slip-systems').removeClass('active');
            }
        }
    };
    Slip.prototype.updateHTML = function () {
        $('#combinations').text(this.combinations);
        $('#system').text(this.system);
        $('#slip-matches').html('');
        $('#slipGamesCounter').text(this.matchCount);
        $('#total-stake').text($('#slip-btn').val());
        var totalOdd = 1;
        for (var key in this.matchOrder) {
            totalOdd = totalOdd * this.playedMatches[this.matchOrder[key]][4];
            var html = this.getMatchHtml(this.matchOrder[key], this.playedMatches[this.matchOrder[key]][1], this.playedMatches[this.matchOrder[key]][2], this.playedMatches[this.matchOrder[key]][3], this.playedMatches[this.matchOrder[key]][4]);
            $('#slip-matches').append(html);
        }
        if (Object.keys(this.matchOrder).length > 0) {
            $('#total-odd').text(totalOdd.toFixed(2));
        }
        else {
            $('#total-odd').text('0.00');
        }
        $('#max-win-amount').text(this.maxWin.toFixed(2));
    };
    Slip.prototype.getMatchHtml = function (matchId, home, away, tip, quota) {
        var html = '<div class="slip-bar">\
                    <div class="virtualf-team-holder">\
                        <div class="team-home">' + home + '</div>-<div class="team-away">' + away + '</div>\
                    </div>\
                    <div class="virtualf-result-holder">\
                        ' + tip + '\
                    </div>\
                    <div class="virtualf-odds-holder">\
                        ' + quota + '\
                    </div>\
                    <div class="slip-x" data-matchid="' + matchId + '">&#10006;</div>\
                </div>';
        return html;
    };
    Slip.prototype.factorial = function (n) {
        return (n < 2) ? 1 : this.factorial(n - 1) * n;
    };
    Slip.prototype.attachListeners = function () {
        var self = this;
        $('body').on('click', '.styled-checkbox', function () {
            if ($(this).is(':checked') !== true) {
                $('.styled-checkbox').prop('checked', false);
                $(this).prop('checked', false);
                self.system = 0;
                $('.slip-systems').removeClass('active');
            }
            else {
                $('.styled-checkbox').prop('checked', false);
                $(this).prop('checked', true);
                self.system = $(this).val();
            }
            self.update();
        });
    };
    return Slip;
}());
exports.default = Slip;



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/ts/slip/slip.ts
// module id = 1990
// module chunks = 6